import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
})
export class SearchPipe implements PipeTransform {
  transform(data: any, searchText: any, modulo: any): any {
    if (!searchText) {
      return data;
    }

    if (!!data) {
      return data.filter((res) => {
        let datos: boolean;
        switch (modulo) {
          case 'historic':
            datos =
              this.getCleanedString(
                `${res.nombre} ${res.autor} ${res.fecha_cierre}`
              )
                .toLowerCase()
                .indexOf(searchText.toLowerCase()) > -1;
            break;
          case 'active_list':
            datos =
              this.getCleanedString(
                `${res.nombre} ${res.autor} ${res.lider} ${res.fecha_creacion}`
              )
                .toLowerCase()
                .indexOf(searchText.toLowerCase()) > -1;
            break;
          case 'actions':
            datos =
              this.getCleanedString(
                `${res.tarea} ${res.responsable} ${res.etapa} ${res.estado}`
              )
                .toLowerCase()
                .indexOf(searchText.toLowerCase()) > -1;
            break;
          default:
            return false;
        }
        return datos;
      });
    }
  }

  getCleanedString(cadena) {
    // Lo queremos devolver limpio en minusculas
    cadena = cadena.toLowerCase();

    // Quitamos acentos y 'ñ'. Fijate en que va sin comillas el primer parametro
    cadena = cadena.replace(/á/gi, 'a');
    cadena = cadena.replace(/é/gi, 'e');
    cadena = cadena.replace(/í/gi, 'i');
    cadena = cadena.replace(/ó/gi, 'o');
    cadena = cadena.replace(/ú/gi, 'u');
    cadena = cadena.replace(/ñ/gi, 'n');
    return cadena;
  }
}
